(function ($) {
    var cfg = window.hcpRegister || {};
    var s = cfg.strings || {};
    var ajaxUrl = cfg.ajaxUrl || "";

    function showMessage(message, type) {
        var $msg = $("#register-message");
        var isError = type === "error";
        $msg.removeClass()
            .addClass(
                isError
                    ? "p-4 bg-red-50 border border-red-200 rounded-lg"
                    : "p-4 bg-green-50 border border-green-200 rounded-lg"
            )
            .html('<p class="text-sm ' + (isError ? "text-red-800" : "text-green-800") + '">' + message + "</p>")
            .removeClass("hidden");

        setTimeout(function () {
            $msg.addClass("hidden");
        }, 5000);
    }

    // Register form
    $("#hcp-register-form").on("submit", function (e) {
        e.preventDefault();

        var $form = $(this);
        var $btn = $("#register-submit-btn");
        var password = $form.find('[name="password"]').val();
        var passwordConfirm = $form.find('[name="password_confirm"]').val();
        var acceptTerms = $form.find('[name="accept_terms"]').is(":checked");
        var acceptPrivacy = $form.find('[name="accept_privacy"]').is(":checked");
        var email = $form.find('[name="email"]').val();

        if (password !== passwordConfirm) {
            showMessage(s.passwordsNoMatch || "", "error");
            return;
        }
        if (!acceptTerms) {
            showMessage(s.acceptTerms || "", "error");
            return;
        }
        if (!acceptPrivacy) {
            showMessage(s.acceptPrivacy || "", "error");
            return;
        }

        var username = email.split("@")[0].replace(/[^a-zA-Z0-9_-]/g, "");

        $btn.prop("disabled", true).text(s.creating || "");

        var tokenPromise = window.hcpRecaptcha
            ? window.hcpRecaptcha.getToken("register")
            : Promise.resolve("");

        tokenPromise.then(function (token) {
            $.ajax({
                url: ajaxUrl,
                method: "POST",
                dataType: "json",
                data: {
                    action: "hcp_register_user",
                    username: username,
                    email: email,
                    first_name: $form.find('[name="first_name"]').val(),
                    last_name: $form.find('[name="last_name"]').val(),
                    password: password,
                    recaptcha_token: token,
                },
            })
                .done(function (data) {
                    if (data.success) {
                        window.location.href = cfg.registeredUrl || "/";
                    } else {
                        showMessage(data.data.message || s.registerFailed || "", "error");
                    }
                })
                .fail(function () {
                    showMessage(s.error || "", "error");
                })
                .always(function () {
                    $btn.prop("disabled", false).text(s.createAccount || "");
                });
        });
    });

    // Password strength indicator
    var strengthLevels = [
        { label: s.strengthNone, color: "#ef4444", width: 0, cls: "text-gray-500" },
        { label: s.strengthWeak, color: "#ef4444", width: 33, cls: "text-red-600" },
        { label: s.strengthStrong, color: "#f59e0b", width: 66, cls: "text-amber-600" },
        { label: s.strengthVeryStrong, color: "#10b981", width: 100, cls: "text-green-600" },
    ];

    $("#reg_password").on("input", function () {
        var pwd = $(this).val();
        var hasLength = pwd.length >= 8;
        var hasUpper = /[A-Z]/.test(pwd);
        var hasLower = /[a-z]/.test(pwd);
        var hasNumber = /[0-9]/.test(pwd);
        var hasSpecial = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(pwd);
        var count = [hasLength, hasUpper, hasLower, hasNumber, hasSpecial].filter(Boolean).length;

        var level = 0;
        if (pwd.length > 0) {
            if (count <= 2) level = 1;
            else if (count === 3 || count === 4) level = 2;
            else level = 3;
        }

        var criteria = [hasLength, hasUpper, hasLower, hasNumber, hasSpecial];
        $('#password-requirements-list li').each(function (i) {
            $(this).find('span').toggleClass('bg-green-400', criteria[i]).toggleClass('bg-red-400', !criteria[i]);
        });

        var lv = strengthLevels[level];
        $("#password-strength-bar").css({ backgroundColor: lv.color, width: lv.width + "%" });
        $("#password-strength-text")
            .text(lv.label || "")
            .attr("class", "text-xs font-medium min-w-20 " + lv.cls);
    });
})(jQuery);
